import React, { useId, useCallback } from "react"
import { Switch } from "@blueprintjs/core"
import { useDispatch } from "react-redux"
import { useAppSelector } from "~/hooks/redux"
import { track } from "~/helpers/analytics"
import { setSmartMatchingEnabled } from "~/Planner/reducer2/smartMatchingSlice"

import { SimpleLabel } from "~/common/labels"
import SmartMatch from "~/common/react-icons/smartMatch"

import styles from "./SmartMatchingToggle.module.css"

type Props = {
  onToggle?: (enabled: boolean) => void
}

const SmartMatchingToggle = ({ onToggle }: Props) => {
  const dispatch = useDispatch()
  const enabled = useAppSelector(
    (state) => state.plannerV2.smartMatching.enabled,
  )
  const labelId = useId()

  const handleChange = useCallback(() => {
    const nextEnabled = !enabled
    if (nextEnabled) {
      track("Smart Matching Enabled")
    } else {
      track("Smart Matching Disabled")
    }
    dispatch(setSmartMatchingEnabled(nextEnabled))
    onToggle?.(nextEnabled)
  }, [dispatch, enabled, onToggle])

  return (
    <div className={styles.container}>
      <SimpleLabel text="Beta" type="beta" />
      <div className={styles.switchContainer}>
        <Switch
          checked={enabled}
          onChange={handleChange}
          aria-labelledby={labelId}
          className={styles.switch}
        />
        <span
          id={labelId}
          className={`${styles.labelText} ${!enabled ? styles.disabled : ""}`}
          onClick={handleChange}
        >
          <SmartMatch color={enabled ? "var(--runn-blue)" : "var(--shadow)"} />
          SmartMatch AI
        </span>
      </div>
    </div>
  )
}

export default SmartMatchingToggle
